'use client'
import Image from 'next/image'
import HeaderSearch from '@/travelmde/components/Common/HeaderSearch'
import { useState } from 'react'
import Link from 'next/link'

const HeaderPopUpMobile = ({
  lang,
  logoImage,
  languages,
  airplaneIcon,
  matchingSlug,
  maincategories,
  currentPath,
  dictionary
}) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <div id="openPopup" className="mobile__menu" onClick={() => setIsOpen(true)}>
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.5 1.69695C0.5 1.44579 0.703606 1.24219 0.954766 1.24219H7.9624C8.21356 1.24219 8.41717 1.44579 8.41717 1.69695V8.70459C8.41717 8.95575 8.21356 9.15936 7.96241 9.15936H0.954766C0.703605 9.15936 0.5 8.95575 0.5 8.70459V1.69695ZM0.5 12.7798C0.5 12.5286 0.703606 12.325 0.954766 12.325H7.9624C8.21356 12.325 8.41717 12.5286 8.41717 12.7798V19.7874C8.41717 20.0386 8.21356 20.2422 7.96241 20.2422H0.954766C0.703605 20.2422 0.5 20.0386 0.5 19.7874V12.7798ZM11.5828 1.69695C11.5828 1.44579 11.7864 1.24219 12.0376 1.24219H19.0452C19.2964 1.24219 19.5 1.44579 19.5 1.69695V8.70459C19.5 8.95575 19.2964 9.15936 19.0452 9.15936H12.0376C11.7864 9.15936 11.5828 8.95575 11.5828 8.70459V1.69695ZM11.5828 12.7798C11.5828 12.5286 11.7864 12.325 12.0376 12.325H19.0452C19.2964 12.325 19.5 12.5286 19.5 12.7798V19.7874C19.5 20.0386 19.2964 20.2422 19.0452 20.2422H12.0376C11.7864 20.2422 11.5828 20.0386 11.5828 19.7874V12.7798Z"
            stroke="#FE9200"
          />
        </svg>
      </div>
      <div id="header__popup" className={`popup-overlay ${isOpen ? '!block' : ''}`}>
        <div className="popup__overlay"></div>
        <div className="popup-content">
          <span id="closePopup" className="close-btn" onClick={() => setIsOpen(false)}>
            &times;
          </span>
          <div className="header__logo dflex mb-15">
            <Link href={`/${lang}`}>
              <Image className="logo__image" src={logoImage} alt="Logo Image" width={200} height={50} />
            </Link>
          </div>
          <div className="header__menu">
            <ul className="menu__list">
              <li className={`${currentPath === '/' ? 'active' : ''}`}>
                <Link href={`/${lang}`} onClick={() => setIsOpen(false)}>{currentPath === '/' ? airplaneIcon : null} Home</Link>
              </li>
              {maincategories.map((category) => (
                <li
                  key={category.id}
                  className={`${currentPath.includes(matchingSlug[category.slug]) ? 'active' : ''}`}
                >
                  <Link
                    href={`/${lang}/main-category/${matchingSlug[category.slug]}/1/${
                      matchingSlug[category.slug].includes('events--prides') ||
                      matchingSlug[category.slug].includes('gay-map') ||
                      matchingSlug[category.slug].includes('hotels') ||
                      matchingSlug[category.slug].includes('saunas')
                        ? 'default'
                        : ''
                    }`}
                    onClick={() => setIsOpen(false)}
                  >
                    {matchingSlug[category.slug] === currentPath ? airplaneIcon : null}
                    {category?.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <HeaderSearch lang={lang} languages={languages} dictionary={dictionary}/>
        </div>
      </div>
    </>
  )
}

export default HeaderPopUpMobile
